<template>
  <div class="home">
    <home-header></home-header>

    <div class="home-body">
      <div class="home-body-aside">
        <div class="collapse" @click="isMenuCollapse = !isMenuCollapse">
          <i
            :class="[
              'el-icon-d-arrow-left',
              'collapse-icon',
              { 'collapse-icon-collapsed': isMenuCollapse }
            ]"
          ></i>
        </div>

        <el-menu
          class="menu"
          background-color="#272a33"
          text-color="#fff"
          :default-active="activeMenuItem"
          :collapse="isMenuCollapse"
        >
          <home-navigate-item
            v-for="navigate in $store.state.page.sidebarMenuItems"
            :key="navigate.name"
            :route="navigate"
            @node-click="handleMenuItemClick"
          >
          </home-navigate-item>
        </el-menu>
      </div>

      <div class="home-body-main">
        <div class="home-body-main-inner">
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item v-for="item in currentBreadcrumbs" :key="item.name" :to="item">{{
                item.meta && item.meta.title ? item.meta.title : '未命名导航'
              }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <div class="container">
            <transition name="fade-transform" mode="out-in">
              <router-view />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PRIMARY_COLOR } from '@/config/variables';
import HomeHeader from './HomeHeader';
import HomeNavigateItem from './HomeNavigateItem';

export default {
  name: 'Home',

  components: {
    HomeHeader,
    HomeNavigateItem
  },

  data() {
    return {
      primaryColor: PRIMARY_COLOR,
      isMenuCollapse: false
    };
  },

  computed: {
    /**
     * 计算当前激活的菜单项
     * 由于菜单并非递归渲染，而是只渲染路由的第一层，因此无法直接使用路由名称作为当前激活的菜单
     * 为了更好的兼容性，此处使用 route.fullPath 比对 route.path 判断是否存在子路由关系
     */
    activeMenuItem() {
      const targetMenuItem = this.$store.state.page.sidebarMenuItems.find(item =>
        this.$route.fullPath.startsWith(item.path)
      );
      return targetMenuItem.path;
    },
    currentBreadcrumbs() {
      return this.$route.matched.filter(route => route.meta && !route.meta.notBreadcrumb);
    }
  },

  created() {
    this.$bus.$on('bus_toggleMenuCollapse', status => {
      this.isMenuCollapse = status;
    });
  },

  methods: {
    onClickLogo() {
      this.$router.push({ name: 'Index' });
    },
    handleMenuItemClick(index) {
      this.$router.push({ name: index.name });
    }
  }
};
</script>

<style lang="scss" scoped>
$size-main-padding: 12px;
$max-width-aside: 240px;
$height-collapse-area: 36px;

.home {
  position: relative;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &-body {
    flex: 1;
    display: flex;
    min-height: 0;

    &-aside {
      height: 100%;
      flex-shrink: 0;

      .collapse {
        height: $height-collapse-area;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgb(39, 42, 51);
        color: #fff;
        cursor: pointer;

        &-icon {
          font-size: 22px;
          transition: 0.2s all ease-in-out;

          &-collapsed {
            transform: rotate(-180deg);
          }
        }
      }

      .menu {
        overflow: auto;
        height: calc(100% - #{$height-collapse-area});
        border-right: 0;

        &:not(.el-menu--collapse) {
          width: 15.6vw;
          max-width: $max-width-aside;
        }

        /deep/ .el-menu-item.is-active {
          background-color: $g-color-primary !important;
          color: #fff;
        }
      }
    }

    &-main {
      flex: 1;
      min-width: 0;
      background-color: #ddd;
      padding: $size-main-padding;

      &-inner {
        height: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: column;

        .breadcrumb {
          display: flex;
          align-items: flex-end;
          padding: 20px 20px 10px 20px;
          flex-shrink: 0;
        }

        .container {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
        }
      }
    }
  }
}
</style>
